(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/slices/containers/actions.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/slices/containers/actions.js');

'use strict';

const ACTION_TYPES = {
  CONTAINER_ADDED: 'CONTAINER_ADDED',
  GAME_FETCHED: 'GAME_FETCHED',
  GAME_GENERATED: 'GAME_GENERATED',
  GAME_SHARE_SOLD: 'GAME_SHARE_SOLD',
  GAME_SOLD_OUT: 'GAME_SOLD_OUT',
  GAME_BUYIN_CLOSED: 'GAME_BUYIN_CLOSED',
  CONTAINER_CLOSED: 'CONTAINER_CLOSED',
  CONTAINER_REMOVED: 'CONTAINER_REMOVED'
};
const actions = {
  containerAdded: update => ({
    type: ACTION_TYPES.CONTAINER_ADDED,
    containerId: update.containerId,
    activatedDrawId: update.activatedDrawId,
    soldShares: update.soldShares,
    productNumeric: update.productId
  }),
  gameFetched: container => ({
    type: ACTION_TYPES.GAME_FETCHED,
    containerId: container.containerId,
    container
  }),
  gameGenerated: update => ({
    type: ACTION_TYPES.GAME_GENERATED,
    containerId: update.containerId,
    activatedDrawId: update.activatedDrawId,
    soldShares: update.soldShares
  }),
  gameShareSold: update => ({
    type: ACTION_TYPES.GAME_SHARE_SOLD,
    containerId: update.containerId,
    soldShares: update.soldShares
  }),
  gameSoldOut: containerId => ({
    type: ACTION_TYPES.GAME_SOLD_OUT,
    containerId
  }),
  gameBuyinClosed: containerId => ({
    type: ACTION_TYPES.GAME_BUYIN_CLOSED,
    containerId
  }),
  containerClosed: containerId => ({
    type: ACTION_TYPES.CONTAINER_CLOSED,
    containerId
  }),
  containerRemoved: containerId => ({
    type: ACTION_TYPES.CONTAINER_REMOVED,
    containerId
  })
};
Object.assign(svs.numbergames.fractiongames.redux.slices.containers, {
  ACTION_TYPES,
  actions
});

 })(window);